"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Navigation = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Navigation",
  componentId: "fl61f5-0"
})(["&:first-child{border-top:0px;}"]);

Navigation.defaultProps = {
  border: 1,
  borderColor: "palette.ink.300",
  borderRadius: "4px",
  overflow: "hidden"
};

/** @component */
exports.default = Navigation;